import { TenantApi } from '@liks/backend-svc-api/esm/apis/TenantApi';
import type { Tenant } from '../types/tenant';
import { backendApiConfiguration } from './backendApi';

export type TenantProfileUpdateInput = {
  /** Current profile used for identity / optimistic locking fields. */
  current: Tenant;
  description: string;
  /**
   * Raw base64 image payload (no data-URL prefix), empty string/null to clear.
   * Omit to leave the existing logo unchanged.
   */
  logo?: string | null;
};

const DATA_URL_PATTERN = /^data:[^;]+;base64,([\s\S]+)$/i;

function toLogoPayload(logo: string | null): string | null {
  if (logo == null) {
    return null;
  }

  const trimmed = logo.trim();
  if (trimmed === '') {
    return null;
  }

  const dataUrlMatch = DATA_URL_PATTERN.exec(trimmed);
  return dataUrlMatch?.[1] ?? trimmed;
}

class TenantService {
  private readonly tenantApi = new TenantApi(backendApiConfiguration);

  async getProfile(): Promise<Tenant> {
    return this.tenantApi.deLiksTenantBoundaryTenantsResourceReadTenant();
  }

  async updateProfile(input: TenantProfileUpdateInput): Promise<Tenant> {
    const { current } = input;

    const description = input.description.trim();

    const body: Record<string, unknown> = {
      name: current.name,
      displayName: current.displayName,
      description: description === '' ? null : description,
    };

    if (input.logo !== undefined) {
      body.logo = toLogoPayload(input.logo);
    }

    return this.tenantApi.deLiksTenantBoundaryTenantsResourceUpdateTenant({
      body: JSON.stringify(body),
    });
  }
}

export const tenantService = new TenantService();
